<template>
	<div class="color-marker"
        :class="{
            'marker-green' : color === 'green',
            'marker-orange' : color === 'orange',
            'marker-red' : color === 'red'
        }">
        <div class="color-marker-outer">
            <div class="color-marker-inner"></div>
        </div>
    </div>
</template>

<script type="text/javascript">

    export default {
        name: 'color-marker',
        props : {
            color : {
                type : String,
                default : 'green'
            }
        }
    }

</script>

<style lang="scss">
    .color-marker {

        display: inline-block;

        .color-marker-outer {
            border-radius : 50%;
            width : 14px;
            height : 14px;
            position : relative;
        }

        .color-marker-inner {
            display: inline-block;
            border-radius : 50%;
            width : 6px;
            height : 6px;
            position : absolute;
            top: 0px;
            left : 0px;
        }

        &.marker-green {
            .color-marker-outer {
                border : $border-green-fade;
            }
            .color-marker-inner {
                background-color : $green-lighten-1;
            }
        }
        &.marker-orange {
            .color-marker-outer {
                border : $border-orange-fade;
            }
            .color-marker-inner {
                background-color : $orange-lighten-1;
            }
        }
        &.marker-red {
            .color-marker-outer {
                border : $border-red-fade;
            }
            .color-marker-inner {
                background-color : $red-lighten-1;
            }
        }
    }
</style>